import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog, ThunderDispatcher, Button, TS_TextArea } from '@nu-art/thunderstorm-frontend/index';
import * as React from 'react';
import './Base_RequestHistory.scss';
import { __stringify } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { Component_MessageCard } from './message-card/Component_MessageCard.js';
export const dispatch_onRequestHistoryChanged = new ThunderDispatcher('__onRequestHistoryChanged');
export class Base_RequestHistory extends ComponentSync {
    listRef = React.createRef();
    __onRequestHistoryChanged() {
        this.forceUpdate();
    }
    _clearHistory = () => {
        this.clearHistory();
        this.forceUpdate();
    };
    convertHistoryMessageToPrint(historyMessage) {
        return historyMessage;
    }
    copyToClipboard = async () => {
        const objectsToCopy = this.getHistory().map(this.convertHistoryMessageToPrint);
        const textToCopy = __stringify(objectsToCopy);
        // await ModuleFE_Thunderstorm.copyToClipboard(__stringify(textToCopy));
        ModuleFE_Dialog.show({
            content: _jsx("div", { className: '', children: _jsxs(LL_V_L, { className: 'copy-area', children: [_jsx(LL_H_C, { className: 'match_width', children: _jsx(ICONS.x.component, { onClick: () => ModuleFE_Dialog.close() }) }), _jsx(TS_TextArea, { type: 'text', value: textToCopy })] }) }), closeOverlayOnClick: () => true
        });
    };
    componentDidMount() {
        setTimeout(this.scrollListToBottom, 10);
    }
    componentDidUpdate() {
        this.scrollListToBottom();
    }
    scrollListToBottom = () => {
        const list = this.listRef.current;
        if (!list)
            return;
        setTimeout(() => list.scroll({ top: list.scrollHeight, behavior: 'smooth' }), 10);
    };
    getPrettyRenderer = (historyItem) => {
        if (historyItem.type === 'error')
            return undefined;
        if (historyItem.type === 'sent')
            return this.prettyMessageView(historyItem);
        return this.prettyResponseView(historyItem);
    };
    getHistoryItemClassName = (historyItem) => {
        return _className('history-item', historyItem.type === 'sent' ? 'sent' : 'received', historyItem.type === 'error' && 'error');
    };
    prettyResponseView = (historyItem) => {
        return undefined;
    };
    prettyMessageView = (historyItem) => {
        return undefined;
    };
    render() {
        return _jsx("div", { className: 'message-history__container', children: _jsxs(LL_V_L, { className: 'message-history', children: [_jsxs(LL_H_C, { children: [_jsx(Button, { className: 'message-history__clear', onClick: this._clearHistory, children: "Clear History" }), _jsx(Button, { className: 'message-history__copy', onClick: this.copyToClipboard, children: "Copy to Clipboard" })] }), _jsx(LL_V_L, { className: 'message-history__list', innerRef: this.listRef, children: this.getHistory().map((historyItem, i) => {
                            const messageClassName = this.getHistoryItemClassName(historyItem);
                            return _jsx(Component_MessageCard, { historyItem: historyItem, className: messageClassName, prettyViewRenderer: this.getPrettyRenderer(historyItem), index: i }, i);
                        }) })] }) });
    }
}
//# sourceMappingURL=Base_RequestHistory.js.map